import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  alpha,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { motion } from 'framer-motion';
import CategoryIcon from '@mui/icons-material/Category';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PublicIcon from '@mui/icons-material/Public';
import WidgetsIcon from '@mui/icons-material/Widgets';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTenantConfig } from '../hooks/useTenant';

export default function ActivityWebFlow() {
  const {tenantName} = useTenantConfig();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: { xs: 10, md: 14 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">

        {/* BAŞLIK */}
        <Box textAlign="center" mb={{ xs: 6, md: 10 }}>
          <Chip
            label="FAALİYET AKIŞI"
            size="small"
            sx={{
              mb: 2,
              backgroundColor: alpha('#059669', 0.12),
              color: '#059669',
              fontWeight: 700,
              fontSize: '0.75rem',
              letterSpacing: '0.8px',
              height: 32,
              px: 2,
              borderRadius: 2,
            }}
          />

          <Typography
            variant="h3" fontWeight={700} mb={2} color="#0f172a"
          >
            Faaliyetler Web Sitesinde
            <br />
            Nasıl Kullanılır?
          </Typography>

          <Typography
              variant="subtitle1"
              sx={{ color: 'text.secondary', fontSize: '1.1rem' }}
          >
            {tenantName}'te faaliyetler bağıştan bağımsızdır.
            İçerik üretimi ve web yayınları için yapılandırılır.
          </Typography>
        </Box>

        {/* AKIŞ */}
        <Grid container spacing={2} alignItems="center">

          <Grid item xs={12} md={2.5}>
            <motion.div
            >
              <FlowCard
                icon={<CategoryIcon />}
                title="Faaliyet Kategorisi"
                desc="Yemek, barınma, eğitim gibi faaliyet alanları tanımlanır."
                color="#059669"
              />
            </motion.div>
          </Grid>

          <Arrow isMobile={isMobile} />

          <Grid item xs={12} md={2.5}>
            <motion.div
            >
              <FlowCard
                icon={<EditNoteIcon />}
                title="Faaliyet İçeriği"
                desc="Açıklama, görsel ve detaylar girilerek içerik oluşturulur."
                color="#0ea5e9"
              />
            </motion.div>
          </Grid>

          <Arrow isMobile={isMobile} />

          <Grid item xs={12} md={2.5}>
            <motion.div
            >
              <FlowCard
                icon={<PublicIcon />}
                title="Web Sitesinde Yayın"
                desc="Faaliyetler web sitesinde sayfa veya liste olarak gösterilir."
                color="#6366f1"
              />
            </motion.div>
          </Grid>

          <Arrow isMobile={isMobile} />

          <Grid item xs={12} md={2.5}>
            <motion.div
            >
              <FlowCard
                icon={<WidgetsIcon />}
                title="Widget Kullanımı"
                desc="Faaliyetler widget'lar aracılığıyla farklı alanlarda sunulur."
                color="#f97316"
              />
            </motion.div>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

/* OK */
function Arrow({ isMobile }) {
  return (
    <Grid item xs={12} md={0.5} sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <ArrowForwardIcon
        sx={{
          fontSize: isMobile ? 28 : 32,
          color: '#cbd5e1',
          transform: isMobile ? 'rotate(90deg)' : 'none',
          transition: 'all 0.3s ease'
        }}
      />
    </Grid>
  );
}

/* KART */
function FlowCard({ icon, title, desc, color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3.5,
        height: '100%',
        minHeight: 220,
        borderRadius: 3,
        border: '2px solid #e5e7eb',
        textAlign: 'center',
        transition: 'all 0.4s ease',
        '&:hover': {
          borderColor: color,
          boxShadow: `0 12px 30px ${alpha(color, 0.15)}`,
          transform: 'translateY(-4px)',
        }
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: 'auto',
          mb: 2.5,
          borderRadius: '50%',
          background: `linear-gradient(135deg, ${alpha(color, 0.2)} 0%, ${alpha(color, 0.1)} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color,
          fontSize: 28,
          border: `2px solid ${alpha(color, 0.3)}`,
        }}
      >
        {icon}
      </Box>

      <Typography
        fontWeight={700}
        mb={1.5}
        sx={{
          fontSize: '1.05rem',
          color: '#0f172a',
          lineHeight: 1.3
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: '#64748b',
          fontSize: '0.9rem',
          lineHeight: 1.5,
          fontWeight: 500
        }}
      >
        {desc}
      </Typography>
    </Paper>
  );
}
